import { useMemo } from 'react';
import { useNarrowView } from './use-narrow-view';

export function useApplyMobileSettings(bannerWidth: number | undefined) {
  const { isNarrowBanner, isNarrowViewport } = useNarrowView(bannerWidth);

  return useMemo(() => {
    if (isNarrowBanner) {
      // don't apply special mobile settings
      return false;
    } else {
      return isNarrowViewport;
    }
  }, [isNarrowBanner, isNarrowViewport]);
}
